"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzHeaderPlaceholder = void 0;
const react_1 = __importDefault(require("react"));
exports.VbzHeaderPlaceholder = ({ redirectUrl }) => {
    return (react_1.default.createElement("div", { className: "vbz-header-placeholder" },
        react_1.default.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
            } },
            react_1.default.createElement("a", { href: redirectUrl || '/home' },
                react_1.default.createElement("span", { className: "vbz-logos smiles" },
                    react_1.default.createElement("b", null, "Smiles"))))));
};
//# sourceMappingURL=index.js.map